export const SiteFooter = () => (
  <footer className="site-footer surface-dark" data-testid="site-footer">
    <div className="container site-footer__inner">
      <div className="site-footer__brand">
        <p className="site-footer__name">AI ARENA <span>· Your AI Officer</span></p>
        <p>Operated by GES j.d.o.o., Pula, Croatia, European Union.</p>
      </div>
      <address className="site-footer__contact">
        <a href="tel:+385996002751" data-testid="footer-phone-link">+385&nbsp;99&nbsp;600&nbsp;27&nbsp;51</a>
        <a href="https://www.aiarena.tech" data-testid="footer-website-link">aiarena.tech</a>
        <a href="https://www.linkedin.com/in/katarina-bulic-bestulic/" target="_blank" rel="noopener" data-testid="footer-linkedin-link">LinkedIn</a>
      </address>
    </div>
  </footer>
);
